import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';
import SignaturePad from 'signature_pad';
import { Eraser, PenLine, Type } from 'lucide-react';
import { Input } from '../components/ui/input';
import { Action } from './Shared';

export const SignatureInput = forwardRef(({name,setName,disabled},ref) => {
  const canvas = useRef(null);
  const pad = useRef(null);
  const [mode,setMode] = useState('draw');
  useEffect(() => {
    if (mode !== 'draw' || !canvas.current) return;
    const element = canvas.current;
    const instance = new SignaturePad(element,{backgroundColor:'#fff',penColor:'#163b43'});
    pad.current = instance;
    let previousWidth = 0;
    const resize = () => {
      const data = instance.toData();
      const width = element.getBoundingClientRect().width;
      const ratio = Math.min(window.devicePixelRatio || 1,2);
      element.width = width * ratio; element.height = width / 3 * ratio;
      element.getContext('2d').scale(ratio,ratio);
      if (previousWidth && data.length) data.forEach(stroke => stroke.points.forEach(point => {point.x *= width / previousWidth; point.y *= width / previousWidth;}));
      instance.clear(); instance.fromData(data); previousWidth = width;
    };
    const observer = new ResizeObserver(resize); observer.observe(element); resize();
    return () => {observer.disconnect();instance.off();pad.current=null;};
  },[mode]);
  useEffect(() => { if (disabled) pad.current?.off(); else pad.current?.on(); },[disabled,mode]);
  useImperativeHandle(ref,() => ({
    async image() {
      if (mode === 'draw') return pad.current && !pad.current.isEmpty() ? pad.current.toDataURL('image/png') : null;
      if (!name.trim()) return null;
      await document.fonts.ready;
      const element = document.createElement('canvas');element.width=900;element.height=300;
      const ctx = element.getContext('2d');ctx.fillStyle='#fff';ctx.fillRect(0,0,900,300);ctx.fillStyle='#163b43';
      let size=64;ctx.font=`${size}px 'Dancing Script', cursive`;
      while(ctx.measureText(name).width > 830 && size > 12) {size -= 1;ctx.font=`${size}px 'Dancing Script', cursive`;}
      ctx.textAlign='center';ctx.textBaseline='middle';ctx.fillText(name,450,150,830);
      return element.toDataURL('image/png');
    }
  }),[name,mode]);
  return <div className="ag-signature-box"><label className="ag-field" htmlFor="agreement-signed-name">Full name of authorised signatory<Input id="agreement-signed-name" data-testid="agreement-signed-name" value={name} maxLength={120} disabled={disabled} onChange={e => setName(e.target.value)} autoComplete="name"/></label>
    <div className="ag-signature-tabs" role="group" aria-label="Signature mode"><Action secondary={mode !== 'draw'} disabled={disabled} data-testid="signature-draw-mode" aria-pressed={mode === 'draw'} onClick={() => setMode('draw')}><PenLine size={16}/>Draw</Action><Action secondary={mode !== 'type'} disabled={disabled} data-testid="signature-type-mode" aria-pressed={mode === 'type'} onClick={() => setMode('type')}><Type size={16}/>Type</Action></div>
    {mode === 'draw' ? <><canvas ref={canvas} className="ag-signature-canvas" aria-label="Draw your signature" data-testid="agreement-signature-canvas"/><Action secondary disabled={disabled} data-testid="signature-clear-button" style={{marginTop:10}} onClick={() => pad.current?.clear()}><Eraser size={15}/>Clear</Action></> : <div className="ag-type-preview" data-testid="typed-signature-preview">{name || 'Your signature'}</div>}
  </div>;
});
SignatureInput.displayName='SignatureInput';